"use client";

import { renderClassName } from "@/utils/renderClassName";
import { useTranslations } from "next-intl";

type BgVideoProps = {
  src: string;
  isLoop?: boolean;
  isAutoplay?: boolean;
  className?: string;
};

const BgVideo = ({
  src,
  isLoop = true,
  isAutoplay = true,
  className,
}: BgVideoProps) => {
  const t = useTranslations("common");
  return (
    <video
      loop={isLoop}
      autoPlay={isAutoplay}
      muted
      controls={false}
      playsInline
      src={src}
      className={renderClassName("bg-video", className)}
      disablePictureInPicture
    >
      <source src={src} type="video/webm" />
      {t("videoSupportText")}
    </video>
  );
};

export default BgVideo;
